<script>
export default {
  name: 'App',
  components: {},
};
</script>

<script setup>
import { onMounted } from 'vue';
import { useAuthStore } from '@/store/auth';

const authStore = useAuthStore();

// Inicializar autenticação ao carregar a aplicação
onMounted(async () => {
  // Tenta buscar dados do usuário se já estiver logado
  await authStore.refreshUserData();
});
</script>

<template>
  <router-view></router-view>
</template>
